<template>
  <div :style="style" class="n-list-title">{{ text }}</div>
</template>
<script>
export default {
  name: 'NListTitle',
  props: {
    lineBreak: Boolean,
    text: String,
    bold: Boolean,
  },
  computed: {
    style() {
      return {
        fontWeight: this.bold ? 600 : 400,
        lineBreak: this.lineBreak ? 'anywhere' : null,
      };
    },
  },
};
</script>
